import { Box } from "@memorang/ui";
import ContentLoader from "react-native-easy-content-loader";

export const QuickStudyButtonSkeleton = () => {
	return (
		<Box paddingTop={16} paddingBottom={16} alignSelf="baseline">
			{/*@ts-ignore*/}
			<ContentLoader
				title={false}
				pRows={1}
				pWidth={151.52}
				pHeight={56}
				paragraphStyles={{ borderRadius: 16, marginVertical: 0 }}
				containerStyles={{ paddingHorizontal: 0, width: 151.52 }}
			/>
		</Box>
	);
};
